<script lang="ts" setup>
import { computed, shallowRef, watch } from 'vue';
import { useRoute } from 'vue-router';
import { can, useTenant } from '@/composables';
import { LAYOUTS } from '@/enum';
import Default from '../Default';
import PublicLayout from '../PublicLayout';
import NotFound from '@/views/Errors/404.vue';

const layout = shallowRef(Default);

const route = useRoute();

const $tenant = useTenant();

const canSee = computed<boolean>(() => (route.meta.permission ? can(route.meta.permission) : true));

const enabledSetting = computed<boolean>(() =>
  route.meta.settings ? $tenant.tenantSettingEnabled(route.meta.settings) : true,
);

watch(
  () => route.meta,
  async (meta) => {
    if (!meta?.layout) {
      layout.value = route.matched[0]?.components?.default;
      return;
    }
    try {
      const component = await import(`@/layouts/${meta.layout}`);
      layout.value = component?.default || Default;
    } catch (e) {
      layout.value = meta.layout === LAYOUTS.DEFAULT ? Default : PublicLayout;
    }
  },
  { immediate: true },
);
</script>

<template>
  <component :is="layout">
    <slot v-if="canSee && enabledSetting" />
    <NotFound v-else />
  </component>
</template>
